export const MESSAGE_TYPES = {
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR",
} as const;

export type MessageType = typeof MESSAGE_TYPES[keyof typeof MESSAGE_TYPES];

// Constants for common messages
const PLEASE_TRY_AGAIN = "Please try again.";

// Constants for success messages
export const Messages = {
    // General Success Messages
    SUCCESS_UPDATE: "Inventory updated successfully.",
    SUCCESS_BULK_UPDATE: "Bulk inventory update completed successfully.",
    SUCCESS_FILE_PARSED: "File parsed successfully.",
    SUCCESS_DATA_PARSED: "Data parsed successfully.",
    SUCCESS_CREATE: "Inventory item created successfully.",
    SUCCESS_DELETE: "Inventory item deleted successfully.",
    SUCCESS_CREATE_TEMPLATE: "Template created successfully.",
    SUCCESS_UPDATE_TEMPLATE: "Template updated successfully.",
    SUCCESS_DELETE_TEMPLATE: "Template deleted successfully.",
    SUCCESS_FETCH_TEMPLATES: "Templates fetched successfully.",
    SUCCESS_PARSE_DATA: "Data parsed successfully.",
    SUCCESS_LOGIN: "Login successful.",
    SUCCESS_LOGOUT: "Logout successful.",
    SUCCESS_REGISTER: "Registration successful.",
    SUCCESS_UPDATE_RECORD: "Record updated successfully.",

    // General Error Messages
    ERROR_GENERAL: `An unexpected error occurred. ${PLEASE_TRY_AGAIN}`,
    ERROR_NO_DATA: "No valid data to submit.",
    ERROR_NO_VALID_DATA: "No valid data available. Please upload or input valid data.",
    ERROR_FETCH_MAPPINGS: `Failed to fetch material mappings. ${PLEASE_TRY_AGAIN}`,
    ERROR_HEADER_MISMATCH: "The header does not match the expected format.",
    ERROR_CREATE: `Failed to create inventory item. ${PLEASE_TRY_AGAIN}`,
    ERROR_DELETE: `Failed to delete inventory item. ${PLEASE_TRY_AGAIN}`,
    ERROR_INVALID_FILE: "Invalid file. Please upload a valid file.",
    ERROR_PARSE_FILE: `Failed to parse the file. ${PLEASE_TRY_AGAIN}`,

    // Inventory Specific Errors
    ERROR_FETCH: `Failed to fetch inventory. ${PLEASE_TRY_AGAIN}`,
    ERROR_UPDATE: `Failed to update inventory. ${PLEASE_TRY_AGAIN}`,
    ERROR_FETCH_HISTORY: `Failed to fetch inventory history. ${PLEASE_TRY_AGAIN}`,
    ERROR_FETCH_TEMPLATES: `Failed to fetch templates. ${PLEASE_TRY_AGAIN}`,
    ERROR_FETCH_TEMPLATE: `Failed to fetch template details. ${PLEASE_TRY_AGAIN}`,
    ERROR_LOAD_MATERIALS: `Failed to load materials. ${PLEASE_TRY_AGAIN}`,
    ERROR_LOAD_SIZES: `Failed to load sizes. ${PLEASE_TRY_AGAIN}`,
    ERROR_LOAD_TYPES: `Failed to load material types. ${PLEASE_TRY_AGAIN}`,
    ERROR_DELETE_TEMPLATE: `Failed to delete the template. ${PLEASE_TRY_AGAIN}`,
    ERROR_CREATE_TEMPLATE: `Failed to create template. ${PLEASE_TRY_AGAIN}`,
    ERROR_UPDATE_TEMPLATE: `Failed to update template. ${PLEASE_TRY_AGAIN}`,
    ERROR_CREATE_MATERIALS: `Failed to create materials. ${PLEASE_TRY_AGAIN}`,
    ERROR_CREATE_TYPES: `Failed to create material types. ${PLEASE_TRY_AGAIN}`,
    ERROR_CREATE_SIZES: `Failed to create material sizes. ${PLEASE_TRY_AGAIN}`,
    ERROR_UPDATE_MATERIAL: `Failed to update `,
    ERROR_DELETE_RECORD: `Failed to delete inventory record. ${PLEASE_TRY_AGAIN}`,
    ERROR_UPDATE_RECORD: `Failed to update inventory record. ${PLEASE_TRY_AGAIN}`,

    // Form and Field Errors
    ERROR_INVALID_FORM: "Invalid form. Please check your input.",
    ERROR_ALL_FIELDS_REQUIRED: "All fields are required. Please fill in all fields.",
    ERROR_NO_MATERIALS: "At least one material is required.",
    ERROR_TEMPLATE_NAME: "Template name cannot be empty.",
    ERROR_MATERIALS: "All materials must have valid type, size, and quantity.",

    // Data Validation Errors
    ERROR_INVALID_DATA: "Invalid data. Please check your input.",
    ERROR_INVALID_ROWS: "Some rows are invalid. Please correct them before submitting.",
    ERROR_MATERIAL_TYPE_NOT_EXIST: "The uploaded Material Type does not exist. Please map to a valid material type.",
    ERROR_MATERIAL_SIZE_NOT_EXIST: "The uploaded Size does not exist. Please map to a valid size.",
    ERROR_INVALID_MATERIAL_TYPE: "Material type is invalid. Please ensure the material type is created before adding the material.",
    ERROR_INVALID_MATERIAL_SIZE: "Material size is invalid. Please ensure the material size is created before adding the material.",
    ERROR_INVALID_COLOR_CODE: "Invalid color code. Please enter a valid color code.",
    ERROR_INVALID_QUANTITY_UNIT: "Invalid quantity unit. Please enter a valid quantity unit.",
    ERROR_DUPLICATE_ENTRY: "Duplicate entries found. Please remove duplicates and try again.",
    ERROR_DUPLICATE_ENTRIES: "Duplicate entries found. Please remove duplicates and try again.",

    // Quantity Errors
    ERROR_QUANTITY_REQUIREMENT: "Either 'Quantity Changed' or 'Remaining Quantity' is required.",
    ERROR_INVALID_QUANTITY: "Invalid quantity. Please enter a valid number.",
    ERROR_INVALID_QUANTITY_CHANGE: "Invalid quantity change. Please enter a valid number.",
    ERROR_INVALID_QUANTITY_REMAINING: "Invalid remaining quantity. Please enter a valid number.",
    ERROR_INVALID_PRICE: "Invalid price. Please enter a valid number.",

    // Authentication Errors
    ERROR_LOGIN: "Login failed.",
    ERROR_LOGOUT: `Logout failed. ${PLEASE_TRY_AGAIN}`,
    ERROR_REGISTER: `Registration failed. ${PLEASE_TRY_AGAIN}`,
    ERROR_PASSWORD_NOT_MATCH: "Passwords do not match. Please try again.",
    ERROR_AUTHORIZATION: "Unauthorized: Please log in again.",
    ERROR_FORBIDDEN: "Forbidden: You do not have permission to access this resource.",

    // Template Specific Errors
    ERROR_TEMPLATE_DETAILS_ARRAY: "Template details response is not an array.",
    ERROR_TEMPLATES_ARRAY: "Templates response is not an array.",

    UNKNOWN_ERROR: `An unknown error occurred. ${PLEASE_TRY_AGAIN}`,
};
